/**
 * bootprompt.js locale configuration
 * locale : Korean
 * author : rigning
 */

import { addLocale } from "../bootprompt";

addLocale("ko", {
  OK: "OK",
  CANCEL: "취소",
  CONFIRM: "확인",
});
